import { useEffect } from 'react'

import CONFIG from '~/config'

const useCookieYes = () => {
  useEffect(() => {
    if (CONFIG.COOKIE_YES_URL) {
      const script = document.createElement('script')
      script.id = 'cookieyes'
      script.type = 'text/javascript'
      script.src = CONFIG.COOKIE_YES_URL
      document.head.appendChild(script)
    }

    return () => {
      const scriptToDelete = document.getElementById('cookieyes')
      if (scriptToDelete) {
        document.head.removeChild(scriptToDelete)
      }
    }
  }, [])
}

export default useCookieYes
